export default {"src":"/_next/static/media/Header.b269fa17.svg","height":903,"width":1440,"blurWidth":0,"blurHeight":0};